var _a, _b, _c;
import { assign, createMachine } from "xstate";
import { getStore, setZipCode, setEstimation, setResidenceType, updateStorage } from "./actions";
import { estimationScreenState } from "./screenStates/Purchaseflow/estimationScreenState";
import { priceScreenState } from "./screenStates/Purchaseflow/priceScreenState";
import { informationScreenState } from "./screenStates/Purchaseflow/informationScreenState";
import { summaryScreenState } from "./screenStates/Purchaseflow/summaryScreenState";
const { estimation, zipCode, residenceType, selectedProductId, productType, startDates } = getStore();
const url = new URL(window.location.href);
const purchaseFlowType = url.searchParams.get("purchaseFlowVersion")
    ? url.searchParams.get("purchaseFlowVersion")
    : "v1";
export const initState = {
    selectedProductId: selectedProductId ? selectedProductId : null,
    estimation: estimation ? estimation : 0,
    person: {},
    startDate: null,
    facility: {
        preSetFacilityId: (_a = url.searchParams.get("aid")) !== null && _a !== void 0 ? _a : undefined,
        preSetAreaId: (_b = url.searchParams.get("oid")) !== null && _b !== void 0 ? _b : undefined,
    },
    invoice: {
        label: "",
        id: 0,
        description: "",
        value: "",
    },
    checkPurchaseId: url.searchParams.get("uuid"),
    additionalProducts: [],
    productType,
    startDates,
    campaign: "",
    facilityInformation: {
        residenceType,
        zipcode: zipCode,
    },
    signId: 0,
    requiresLimePurchase: false,
    forceShowEstimation: false,
    purchaseFlowType: purchaseFlowType,
    hasFetchedPersonAutomatic: false,
};
if (url.searchParams.get("forbrukning") && url.searchParams.get("postnr")) {
    const forbrukning = url.searchParams.get("forbrukning");
    if (forbrukning) {
        initState.estimation = +forbrukning;
    }
    initState.facilityInformation.zipcode = (_c = url.searchParams.get("postnr")) !== null && _c !== void 0 ? _c : "";
    initState.facilityInformation.residenceType = initState.estimation < 7500 ? "apartment" : "house";
    initState.forceShowEstimation = true;
    updateStorage({
        zipCode: initState.facilityInformation.zipcode,
        estimation: initState.estimation,
        residenceType: "house",
    });
}
const getInitialScreen = () => {
    const skipEstimation = (estimation && estimation > 0 && zipCode && (residenceType === "apartment" || residenceType === "house"));
    if (initState.forceShowEstimation) {
        return "estimation";
    }
    else if (skipEstimation && selectedProductId) {
        return "information";
    }
    else if (skipEstimation) {
        return "price";
    }
    return "estimation";
};
export const purchaseflowStore = createMachine({
    id: "purchaseFlow",
    predictableActionArguments: false,
    initial: getInitialScreen(),
    context: initState,
    on: {
        SET_PRODUCT_ID: {
            actions: assign({
                selectedProductId: (context, event) => event.selectedProductId,
            }),
        },
        SET_CAMPAIGN: {
            actions: assign({
                campaign: (context, event) => event.campaign,
            }),
        },
        SET_PURCHASE_FLOW_TYPE: {
            actions: assign({
                purchaseFlowType: (context, event) => event.purchaseFlowType,
            }),
        },
    },
    states: {
        estimation: estimationScreenState,
        price: priceScreenState,
        information: informationScreenState,
        summary: summaryScreenState,
        confirmation: {},
    },
}, {
    actions: {
        setZipCode,
        setEstimation,
        setResidenceType,
    },
});
export const getUrl = (key) => {
    switch (key) {
        case "estimation":
            return "forbrukning";
        case "price":
            return "avtal";
        case "information":
            return "uppgifter";
        case "summary":
            return "summering";
        case "confirmation":
            return "tack";
        default:
            return key;
    }
};
